import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { of, filter, concatMap, finalize, Subscription, Subject } from 'rxjs';
import { tap, map, switchMap, debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { SecurityGroups } from 'src/app/shared/securitygroups';
import { Client } from 'src/app/shared/client';
import { Document } from 'src/app/shared/document';
import { ClientApiService } from 'src/app/services/client-api.service';

@Component({
  selector: 'app-new-document-dlg-dates',
  templateUrl: './new-document-dlg-dates.component.html',
  styleUrls: ['./new-document-dlg-dates.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NewDocumentDlgDatesComponent implements OnInit, OnChanges, OnDestroy {

  @Input() data1Label: string = 'Дата счета:';
  @Input() data2Label: string = 'Действителен до:';
  @Input() data3Label: string = 'Дата выполнения:';
  @Input() currLabel: string = 'Валюта документа:';
  @Input() lcoLabel: string = 'Юридическое лицо продавца:';
  @Input() pcoPerLabel: string = 'Представитель продавца:';
  @Input() sgrpLabel: string = 'Минимальная группа для доступа:';

  @Input() dateFormat: string = 'dd.mm.yy';

  @Input()  parentDocument: Document;

  @Input() newDocument: Document;

  @Input() selectDepartmentOn: boolean = false;

  @Input() manDepLabel: string;

  @Output() newDocumentUpdate: EventEmitter<Document> = new EventEmitter();

  public get hasParentDocument(): boolean { return (this.parentDocumentId && true); }

  parentDocumentId: number;
  private _depChildQuery: Subscription;

  cliCompany: Client;

  DOCDATE: Date;
  DOCVALDATE: Date;
  DOCEXPDATE: Date;

  showTime: boolean = true;

  private _newDocumentUpdateQuery: Subscription = null;

  private newDocumentUpdateSubs$ = new Subject<Document>();

  constructor(
    private cliApi: ClientApiService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** NewDocumentDlgDatesComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** NewDocumentDlgDatesComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** NewDocumentDlgDatesComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {

        case 'newDocument':
          this.DOCDATE = new Date(this.newDocument.DOCDATE);
          this.DOCVALDATE = new Date(this.newDocument.DOCVALDATE);
          this.DOCEXPDATE = new Date(this.newDocument.DOCEXPDATE);
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** NewDocumentDlgDatesComponent in ngOnDestroy')

    if (this._newDocumentUpdateQuery) { this._newDocumentUpdateQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** NewDocumentDlgDatesComponent in ngOnInit');

    this._newDocumentUpdateQuery =
      this.newDocumentUpdateSubs$.pipe(
        debounceTime(20),
        // distinctUntilChanged(),
        tap(document => environment.production || console.log('*** NewDocumentDlgDatesComponent newDocumentUpdateSubs$: ' + JSON.stringify(document))),
        map(document => this.newDocumentUpdate.emit(document)),
      )
        .subscribe();
  }

  onDateSelect(event) {
    console.log('*** NewDocumentDlgDatesComponent onDateSelect  ' + JSON.stringify(event));

    this.newDocument.DOCDATE = this.DOCDATE;

    this.newDocumentUpdateSubs$.next(this.newDocument);
  }

  onDateValSelect(event) {
    console.log('*** NewDocumentDlgDatesComponent onDateValSelect  ' + JSON.stringify(event));

    this.newDocument.DOCVALDATE = this.DOCVALDATE;

    this.newDocumentUpdateSubs$.next(this.newDocument);
  }

  onDateExpSelect(event) {
    console.log('*** NewDocumentDlgDatesComponent onDateExpSelect  ' + JSON.stringify(event));

    this.newDocumentUpdate.emit(this.newDocument);
    this.newDocument.DOCEXPDATE = this.DOCEXPDATE;
    this.newDocumentUpdateSubs$.next(this.newDocument);
  }

  onCurrencySelection(event) {
    console.log('*** NewDocumentDlgDatesComponent onCurrencySelection  ' + JSON.stringify(event));

    if (this.newDocument.DOCCURRID != event.CURID) {
      this.newDocument.DOCCURRID = event.CURID;
    }
    this.newDocument.DOCRATEVAL = event.CURRATE;

    if (this.newDocument.items) {
      this.newDocument.items.forEach(di => {
        di.DOCITEMCURRID = event.CURID;
        di.DOCITEMCRATE = event.CURRATE;
      });
    }
    //this.newDocumentUpdateSubs$.next(this.newDocument);
  }

  lcoCompanySelected(event) {
    console.log('*** NewDocumentDlgDatesComponent lcoCompanySelected  ' + JSON.stringify(event));

    this.newDocument.DOCLCOCLIID = event;

    this._depChildQuery =

      this.cliApi.getChildDepartmentsById(this.newDocument.DOCMANDEPID, this.newDocument.DOCLCOCLIID).pipe(

        // Both lookups can legitimately come back with nothing -- a local company with no
        // child department, or none of its contacts marked responsible -- and both used to
        // be dereferenced blind (`data[0].CLIID`, `prs.find(...).PERSID`), throwing a
        // TypeError that killed the chain and left DOCLCODEPID/DOCLCOPERID stale while the
        // manager saw only a console error. The fallbacks below are the ones
        // create-new-document's fillInChildDocumentDepartmentAndPerson() already applies
        // for the same two fields, so a company that resolves one way there resolves the
        // same way here.
        concatMap(data => {
          this.newDocument.DOCLCODEPID = (data && data.length > 0) ? data[0].CLIID : this.newDocument.DOCMANDEPID;

          return this.cliApi.getPersonsByClientId(this.newDocument.DOCLCOCLIID);
        }),

        concatMap(prs => {
          const dir = (prs || []).sort((a, b) => (b.PERSRESPONSIBLE - a.PERSRESPONSIBLE)).find(pr => pr.PERSRESPONSIBLE > 0);
          if (dir) {
            this.newDocument.DOCLCOPERID = dir.PERSID;
          } else if (prs && prs.length > 0) {
            this.newDocument.DOCLCOPERID = prs[0].PERSID;
          } else {
            this.newDocument.DOCLCOPERID = this.newDocument.DOCMANPERID;
          }

          return of(true);
        }),

        finalize(() => {
          this.newDocumentUpdateSubs$.next(this.newDocument);
        })
      ).subscribe({
        // An HTTP failure in either lookup errors the chain. Without a handler that reaches
        // Angular's global ErrorHandler as an uncaught error; logged here instead, in the
        // same shape as this component's other diagnostics.
        error: err => console.error('*** NewDocumentDlgDatesComponent lcoCompanySelected: Error: ', err),
      });

  //  this._depChildQuery =
  //    concat(
  //      this.cliApi.getChildDepartmentsById(this.newDocument.DOCMANDEPID, this.newDocument.DOCLCOCLIID)
  //        .pipe(map(data => this.newDocument.DOCLCODEPID = data[0].CLIID)),

  //      this.cliApi.getPersonsByClientId(this.newDocument.DOCLCOCLIID)
  //        .pipe(map(prs => this.newDocument.DOCLCOPERID = prs.find(pr => pr.PERSRESPONSIBLE > 0).PERSID)),

  //      of(true).pipe(map(val => (this.newDocumentUpdate.emit(this.newDocument))))
  //  )
  //    .subscribe();
  }

  onSelectedSecurityGroup(sg: SecurityGroups) {
    console.log('*** NewDocumentDlgDatesComponent in onSelectedSecurityGroup: ' + JSON.stringify(sg));
    this.newDocument.SGMGROUPID = sg.SECGROUPID;
    this.newDocumentUpdateSubs$.next(this.newDocument);
  }

  mainStockSelected(selectedId) {
    console.log('*** NewDocumentDlgDatesComponent in mainStockSelected: ' + selectedId);

    this.newDocument.DOCMANDEPID = selectedId;

    this._depChildQuery =
      this.cliApi.getChildDepartmentsById(this.newDocument.DOCMANDEPID, this.newDocument.DOCLCOCLIID)
      .pipe(
        filter(data => data && data.length > 0),

        map(data => {
          this.newDocument.DOCLCODEPID = data[0].CLIID;
        }),

        finalize(() => {
          environment.production || console.log('*** NewDocumentDlgDatesComponent in mainStockSelected: ' + JSON.stringify(this.newDocument));
          this.newDocumentUpdateSubs$.next(this.newDocument);
        })
      )
        .subscribe();
  }
}
